export default __webpack_public_path__ + "static/media/miguel-lopes-8.e831cea0.jpg";